<template>
  <div class="modal-card up-modal">
    <header class="modal-card-head up-modal-head">
      <div class="up-modal-icon" :class="type === 'ST' ? 'is-teacher' : 'is-student'">
        <svg v-if="type === 'ST'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
        <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <div>
        <h2 class="up-modal-title">Add {{ type === 'ST' ? 'Teacher' : 'Student' }}</h2>
        <p class="up-modal-sub">{{ type === 'ST' ? 'Create a teaching account for your school.' : 'Create a student account linked to a parent.' }}</p>
      </div>
      <button class="up-modal-close" type="button" @click="$parent.close()" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </header>

    <section class="modal-card-body up-modal-body">
      <div class="up-grid">
        <div class="up-field">
          <label class="up-label">Full Name <span class="req">*</span></label>
          <input
            v-model="schoolUser.name"
            type="text"
            class="up-input"
            placeholder="e.g. Priya Sharma"
            required
          />
        </div>
        <div class="up-field">
          <label class="up-label">Email <span class="req">*</span></label>
          <input
            v-model="schoolUser.email"
            type="email"
            class="up-input"
            placeholder="e.g. priya@school.edu"
            required
          />
        </div>
        <div class="up-field">
          <label class="up-label">Mobile <span class="req">*</span></label>
          <input
            v-model="schoolUser.mobile"
            type="tel"
            class="up-input"
            placeholder="10-digit number"
            required
          />
        </div>
        <div class="up-field">
          <label class="up-label">Password <span class="req">*</span></label>
          <div class="up-input-wrap">
            <input
              v-model="schoolUser.password"
              :type="showPassword ? 'text' : 'password'"
              class="up-input"
              placeholder="Set a password"
              required
            />
            <button type="button" class="up-eye" @click="showPassword = !showPassword" :aria-label="showPassword ? 'Hide password' : 'Show password'">
              <svg v-if="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.17-5.94"></path><path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
            </button>
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot up-modal-foot">
      <button class="up-btn up-btn-ghost" type="button" @click="$parent.close()">Cancel</button>
      <button class="up-btn up-btn-primary" :disabled="isLoading" @click="proceed()">
        <span v-if="!isLoading">Create {{ type === 'ST' ? 'Teacher' : 'Student' }}</span>
        <span v-else>Creating…</span>
      </button>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'set-user',
  props: {
    type: { type: String, default: 'ST' }
  },
  data() {
    return {
      isLoading: false,
      showPassword: false,
      schoolUser: {
        name: '',
        email: '',
        mobile: '',
        type: this.type,
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getTeacherToken'])
  },
  methods: {
    ...mapActions(['createSchoolUser']),
    proceed() {
      if (!this.schoolUser.name || !this.schoolUser.email || !this.schoolUser.mobile || !this.schoolUser.password) {
        this.$buefy.toast.open({ message: 'Please fill in all required fields', type: 'is-warning' })
        return
      }
      this.isLoading = true
      this.createSchoolUser({
        schoolUser: this.schoolUser,
        token: this.getTeacherToken
      }).then(() => {
        this.isLoading = false
        this.$emit('over')
        this.$buefy.toast.open({
          message: `${this.type === 'ST' ? 'Teacher' : 'Student'} created successfully`,
          type: 'is-success'
        })
      }).catch(err => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: (err.response && err.response.data && err.response.data.msg) || 'Could not create user',
          type: 'is-danger'
        })
      })
    }
  }
}
</script>

<style scoped>
.up-modal.modal-card {
  width: min(560px, 95vw);
  max-width: 95vw;
  background: #ffffff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
}

.up-modal-head.modal-card-head {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1.25rem 1.4rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, #fafbfd, #ffffff);
  position: relative;
  border-radius: 0;
}

.up-modal-icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.15);
}

.up-modal-icon.is-teacher {
  background: linear-gradient(135deg, #8919e7, #6b38c7);
}

.up-modal-icon.is-student {
  background: linear-gradient(135deg, #31c8ff, #4361ee);
}

.up-modal-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  letter-spacing: -0.01em;
}

.up-modal-sub {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0.1rem 0 0;
}

.up-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(15, 23, 42, 0.05);
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.up-modal-close:hover {
  background: #1f2937;
  color: #ffffff;
}

.up-modal-body.modal-card-body {
  padding: 1.25rem 1.4rem;
  background: #ffffff;
  flex: 1 1 auto;
  overflow-y: auto;
}

.up-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.9rem 0.9rem;
}

.up-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.up-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.01em;
}

.up-label .req {
  color: #ef4444;
  margin-left: 2px;
}

.up-input-wrap {
  position: relative;
}

.up-input {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  background: #ffffff;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  font-size: 0.95rem;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.up-input:hover {
  border-color: #cbd5e1;
}

.up-input:focus {
  border-color: #8919e7;
  box-shadow: 0 0 0 3px rgba(137, 25, 231, 0.12);
}

.up-input-wrap .up-input {
  padding-right: 2.4rem;
}

.up-eye {
  position: absolute;
  right: 0.55rem;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;
}

.up-eye:hover {
  background: rgba(15, 23, 42, 0.05);
  color: #1f2937;
}

.up-modal-foot.modal-card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 1rem 1.4rem 1.25rem;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fafbfd;
  border-radius: 0;
}

.up-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.65rem 1.1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.up-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.up-btn-ghost {
  background: transparent;
  color: #475569;
  border: 1px solid rgba(15, 23, 42, 0.1);
}

.up-btn-ghost:hover {
  background: rgba(15, 23, 42, 0.04);
  color: #1f2937;
}

.up-btn-primary {
  background: linear-gradient(135deg, #8919e7, #6b38c7);
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(137, 25, 231, 0.28);
}

.up-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(137, 25, 231, 0.36);
}

@media screen and (max-width: 540px) {
  .up-grid {
    grid-template-columns: 1fr;
  }
  .up-modal-foot {
    flex-direction: column-reverse;
  }
  .up-btn {
    width: 100%;
  }
}
</style>
